/**
 * API-слой модуля «Школы».
 *
 * Соответствие постановке (п.4):
 *   GET /api/schools/meta                            — значения фильтров
 *   GET /api/schools/dashboard?shift=&lang=&status=   — данные экрана (summary/cuts/items)
 *   GET /api/schools/export?format=xlsx|pdf&...        — файл целиком формирует бэкенд
 *
 * ВАЖНО: весь расчёт (загруженность, дефицит, статус) и вся агрегация (summary, cuts,
 * items) — на бэкенде. Фронтенд только отображает ответ и ничего не пересчитывает.
 * Поэтому при USE_MOCK функции buildMeta/buildDashboard имитируют бэкенд: держат «сырые»
 * строки и возвращают ровно тот ответ, что придёт из API. Код экрана в моке и в проде
 * одинаков. Экспорт: фронтенд НЕ подключает библиотек выгрузки и НЕ собирает файл сам.
 *
 * РЕАЛЬНЫЙ БЭКЕНД (когда поставите USE_MOCK=false в constants.js):
 *   1) раскомментируйте два импорта ниже и приведите пути к вашим (как в остальных модулях);
 *   2) раскомментируйте тело функции realGet;
 *   3) в buildExportUrl верните префикс API_ROOT (см. пометку там).
 * Пока USE_MOCK=true модуль ни от getNetwork, ни от API_ROOT не зависит и собирается чисто.
 */
// import { getNetwork } from '../../utils/network'; // TODO: путь как в остальных модулях
// import { API_ROOT } from '../../config';          // TODO: путь как в остальных модулях
import { USE_MOCK, SCHOOLS_API } from './constants';

// ============================================================================
//  МОК-БЭКЕНД  (в проде удаляется вместе с блоком; остаются только fetch-функции)
// ============================================================================

// «Сырые» строки школ — реальная выгрузка public.vko_school_info (20 строк).
// name/addr в БД хранятся одним значением и одинаковы в обоих языках.
const RAW = [
  { id: 1,  name: '№1 жалпы орта білім беретін мектеп',                              addr: '060100 Құлсары қаласы, Махамбет даңғылы 1365-45-79',            cap: 1176, shift: 2, kz: true, ru: false, st: 1238, tch: 129 },
  { id: 2,  name: '№2 жалпы орта білім беретін мектеп',                              addr: '060108 Қосшағыл ауылы, Жайық 93',                              cap: 880,  shift: 2, kz: true, ru: false, st: 733,  tch: 99  },
  { id: 3,  name: '№3 жалпы орта білім беретін мектеп',                              addr: '060111 Шоқпартоғай ауылы, Т.Дешенов көшесі 378 ғимарат',       cap: 440,  shift: 2, kz: true, ru: false, st: 625,  tch: 71  },
  { id: 4,  name: '№4 М.Әуезов атындағы жалпы орта білім беретін мектеп',            addr: '060110 Тұрғызба ауылы, Бөкен би 409',                          cap: 620,  shift: 2, kz: true, ru: false, st: 725,  tch: 91  },
  { id: 5,  name: '№5 Абай атындағы жалпы орта білім беретін мектеп',                addr: '060103 Құлсары қаласы, Дүйсенғали Әжіғалиев, құрылыс 67',       cap: 300,  shift: 2, kz: true, ru: false, st: 597,  tch: 76  },
  { id: 6,  name: '№6 жалпы орта білім беретін мектеп',                              addr: '060100 Құлсары қаласы, Махамбет даңғылы, 72',                  cap: 940,  shift: 2, kz: true, ru: true,  st: 2154, tch: 127 },
  { id: 7,  name: '№7 Е.Халықов атындағы жалпы орта білім беретін мектеп',           addr: '060100 Құлсары қаласы, Күржәманұлы Қашаған көшесі 53 ғимарат',  cap: 1200, shift: 1, kz: true, ru: false, st: 574,  tch: 89  },
  { id: 8,  name: '№8 жалпы орта білім беретін мектеп',                              addr: '060100 Құлсары қаласы, 199 көше 8 ғимарат',                    cap: 600,  shift: 2, kz: true, ru: true,  st: 1339, tch: 124 },
  { id: 9,  name: '№9 жалпы орта білім беретін мектеп',                              addr: '060100 Құлсары қаласы, Махамбет даңғылы 102',                  cap: 1160, shift: 2, kz: true, ru: true,  st: 1618, tch: 119 },
  { id: 10, name: '№10 Амангелді атындағы жалпы орта білім беретін мектеп',          addr: '060104 Ақкиізтоғай ауылы, С.Аронұлы 210',                      cap: 320,  shift: 2, kz: true, ru: false, st: 350,  tch: 45  },
  { id: 11, name: '№13 жалпы орта білім беретін мектеп',                             addr: '060101 Құлсары қаласы, Тәуекел Хан көшесі ғимарат 2',          cap: 600,  shift: 2, kz: true, ru: false, st: 929,  tch: 80  },
  { id: 12, name: '№15 Сүлеймен Карабалин атындағы жалпы орта білім беретін мектеп', addr: '060102 Құлсары қаласы, А.Қорғанбаев көшесі, 50',               cap: 488,  shift: 2, kz: true, ru: false, st: 408,  tch: 47  },
  { id: 13, name: '№16 Д.Жазықбаев атындағы жалпы орта білім беретін мектеп',        addr: '060100 Құлсары қаласы, 217 көше 42 ғимарат',                   cap: 754,  shift: 2, kz: true, ru: true,  st: 1016, tch: 104 },
  { id: 14, name: '№17 жалпы орта білім беретін мектеп',                             addr: '060105 Майкөмген ауылы, Ақтан Керейулы №56',                   cap: 260,  shift: 2, kz: true, ru: false, st: 236,  tch: 34  },
  { id: 15, name: '№18 М.Сатыбалдиев атындағы жалпы орта білім беретін мектеп',      addr: '060100 Құлсары қаласы, 221 көше №59 үй',                       cap: 1580, shift: 2, kz: true, ru: true,  st: 2334, tch: 193 },
  { id: 16, name: '№19 жалпы орта білім беретін мектеп',                             addr: '060100 Құлсары қаласы, Н.Арқабаев көшесі, 22 ғимарат',         cap: 300,  shift: 2, kz: true, ru: false, st: 645,  tch: 82  },
  { id: 17, name: '№20 жалпы орта білім беретін мектеп',                             addr: '060100 Құлсары қаласы, Балуан Шолақ, ғимарат-1',               cap: 340,  shift: 2, kz: true, ru: false, st: 312,  tch: 44  },
  { id: 18, name: '№21 жалпы орта білім беретін мектеп',                             addr: '060100 Құлсары қаласы, Ж.Нұрмахан көшесі 3 ғимарат',           cap: 300,  shift: 2, kz: true, ru: false, st: 1070, tch: 92  },
  { id: 19, name: '№22 жалпы орта білім беретін мектеп',                             addr: '060106 Жаңа Каратон кенті, Боран Ержанов көшесі, құрылыс 642', cap: 720,  shift: 2, kz: true, ru: true,  st: 848,  tch: 95  },
  { id: 20, name: '№23 жалпы орта білім беретін мектеп',                             addr: '060106 Жаңа Каратон кенті, Рзиев Балагул №883 ғимарат',        cap: 436,  shift: 2, kz: true, ru: true,  st: 545,  tch: 75  },
];

// Справочники подписей (в проде отдаёт бэкенд как label_ru / label_kk).
const SHIFT_LABELS = {
  1: { ru: 'Односменная', kk: 'Бір ауысымды' },
  2: { ru: 'Двухсменная', kk: 'Екі ауысымды' },
};
const LANG_LABELS = {
  kz:   { ru: 'Казахский',           kk: 'Қазақ' },
  ru:   { ru: 'Русский',             kk: 'Орыс' },
  both: { ru: 'Казахский и русский', kk: 'Қазақ және орыс' },
  none: { ru: 'Не указан',           kk: 'Көрсетілмеген' },
};
const STATUS_LABELS = {
  good:    { ru: 'В пределах мощности', kk: 'Қуат шегінде' },
  bad:     { ru: 'Превышение мощности', kk: 'Қуаттан асқан' },
  no_data: { ru: 'Нет данных',          kk: 'Дерек жоқ' },
};
const shiftLabel = (sh) => SHIFT_LABELS[sh] || { ru: `${sh} смен`, kk: `${sh} ауысым` };

function langGroup(s) {
  if (s.kz && s.ru) return 'both';
  if (s.kz) return 'kz';
  if (s.ru) return 'ru';
  return 'none';
}

// Расчётные поля (в проде их считает бэкенд): загруженность, дефицит, статус.
function computeRow(s, sortOrder) {
  const cap = s.cap;
  const st = s.st;
  const hasData = cap != null && cap > 0 && st != null;
  const load = hasData ? Math.round((st / cap) * 1000) / 10 : null;
  const status = !hasData ? 'no_data' : load <= 100 ? 'good' : 'bad';
  const lg = langGroup(s);
  return {
    id: s.id,
    sort_order: sortOrder,
    name: s.name,
    address: s.addr,
    capacity: cap,
    students: st,
    load_pct: load,
    deficit: hasData ? Math.max(st - cap, 0) : null,
    teachers: s.tch,
    shift: s.shift,
    shift_label_ru: shiftLabel(s.shift).ru,
    shift_label_kk: shiftLabel(s.shift).kk,
    lang: lg,
    lang_label_ru: LANG_LABELS[lg].ru,
    lang_label_kk: LANG_LABELS[lg].kk,
    status,
  };
}
const ROWS = RAW.map((s, i) => computeRow(s, i + 1));

const applyFilters = (rows, { shift, lang, status } = {}) =>
  rows.filter(
    (r) =>
      (!shift || String(r.shift) === String(shift)) &&
      (!lang || r.lang === lang) &&
      (!status || r.status === status)
  );

// GET /api/schools/meta
function buildMeta() {
  const shifts = [...new Set(ROWS.map((r) => r.shift))].sort((a, b) => a - b);
  const langs = ['kz', 'ru', 'both', 'none'].filter((g) => ROWS.some((r) => r.lang === g));
  const statuses = ['good', 'bad', 'no_data'].filter((s) => ROWS.some((r) => r.status === s));
  return {
    filters: {
      shift: shifts.map((v) => ({ value: String(v), label_ru: shiftLabel(v).ru, label_kk: shiftLabel(v).kk })),
      lang: langs.map((v) => ({ value: v, label_ru: LANG_LABELS[v].ru, label_kk: LANG_LABELS[v].kk })),
      status: statuses.map((v) => ({ value: v, label_ru: STATUS_LABELS[v].ru, label_kk: STATUS_LABELS[v].kk })),
    },
  };
}

// GET /api/schools/dashboard?shift=&lang=&status=
function buildDashboard(filters = {}) {
  const rows = applyFilters(ROWS, filters);
  const summary = {
    total: rows.length,
    good: rows.filter((r) => r.status === 'good').length,
    bad: rows.filter((r) => r.status === 'bad').length,
    students_total: rows.reduce((a, r) => a + (r.students || 0), 0),
    capacity_total: rows.reduce((a, r) => a + (r.capacity || 0), 0),
    deficit_total: rows.reduce((a, r) => a + (r.deficit || 0), 0),
  };
  const cut = (keys, count, labelOf) =>
    keys
      .map((key) => ({ key: String(key), label_ru: labelOf(key).ru, label_kk: labelOf(key).kk, n: count(key) }))
      .filter((c) => c.n > 0);
  const shiftKeys = [...new Set(ROWS.map((r) => r.shift))].sort((a, b) => a - b);
  const cuts = {
    by_shift: cut(shiftKeys, (k) => rows.filter((r) => r.shift === k).length, shiftLabel),
    by_lang: cut(['kz', 'ru', 'both', 'none'], (k) => rows.filter((r) => r.lang === k).length, (k) => LANG_LABELS[k]),
    by_status: cut(['good', 'bad', 'no_data'], (k) => rows.filter((r) => r.status === k).length, (k) => STATUS_LABELS[k]),
  };
  const items = rows.slice().sort((a, b) => a.sort_order - b.sort_order);
  return { summary, cuts, items };
}

const MOCK_DELAY = 200;
const mock = (payload) => new Promise((resolve) => setTimeout(() => resolve(payload), MOCK_DELAY));

// ============================================================================
//  ПУБЛИЧНЫЕ FETCH-ФУНКЦИИ
// ============================================================================

/** Значения фильтров. */
export async function fetchMeta() {
  if (USE_MOCK) return mock(buildMeta());
  return realGet('/meta');
}

/** Данные экрана. @param {{shift?:string, lang?:string, status?:string}} filters */
export async function fetchDashboard(filters = {}) {
  if (USE_MOCK) return mock(buildDashboard(filters));
  const params = {};
  if (filters.shift) params.shift = filters.shift;
  if (filters.lang) params.lang = filters.lang;
  if (filters.status) params.status = filters.status;
  return realGet('/dashboard', { params });
}

/**
 * Реальный GET к бэкенду. Пока USE_MOCK=true — НЕ вызывается, поэтому модуль не зависит
 * от getNetwork/API_ROOT и собирается чисто. Включение бэкенда: раскомментируйте импорты
 * сверху и две строки в теле, удалив throw.
 */
// eslint-disable-next-line no-unused-vars
async function realGet(path, config) {
  throw new Error('Schools: USE_MOCK=false, но реальный бэкенд ещё не подключён (см. api.js).');
  // const res = await getNetwork().get(`${API_ROOT}${SCHOOLS_API}${path}`, config);
  // return res.data;
}

/**
 * Адрес выгрузки. Никаких запросов здесь нет — только сборка URL.
 * locale — язык ИНТЕРФЕЙСА (ru/kk); lang — фильтр по языку ОБУЧЕНИЯ. Не путать.
 * @param {'xlsx'|'pdf'} format
 * @param {{shift?:string, lang?:string, status?:string, locale:string}} state
 */
export function buildExportUrl(format, state) {
  const p = new URLSearchParams({ format, locale: state.locale });
  if (state.shift) p.set('shift', state.shift);
  if (state.lang) p.set('lang', state.lang);
  if (state.status) p.set('status', state.status);
  // Для реального бэкенда добавьте префикс API_ROOT: `${API_ROOT}${SCHOOLS_API}/export?...`
  const base = '';
  return `${base}${SCHOOLS_API}/export?${p.toString()}`;
}
